import map from 'lodash/map';
import { computed } from 'mobx';

import { LaboratoryServiceData } from 'chaika-frontend-types/frontend-cms';

import { SimpleList } from '@store/models/SimpleList';

interface FilterParams {
    serviceId?: string;
    laboratoryId?: string;
    loinc?: string;
}

export class LaboratoryServiceList extends SimpleList<LaboratoryServiceData, FilterParams> {
    @computed
    public get laboratoryServiceIds(): string[] {
        return map(this.values, 'serviceId');
    }

    protected filterValue(value: LaboratoryServiceData, filter: FilterParams): boolean {
        return (
            this.filterFieldValue(value, filter.serviceId, 'serviceId') &&
            this.filterFieldValue(value, filter.laboratoryId, 'laboratoryId') &&
            this.filterFieldValue(value, filter.loinc, 'loinc')
        );
    }
}
